import { Component } from '@angular/core';

import { SuburbCatalogueService } from '../workspace/catalogue.service';
import { MapToolsService } from '../workspace/map-tools.service';
import { PanelNavService } from '../workspace/panel-nav.service';
import { WorkspaceStateService } from '../workspace/workspace-state.service';

/**
 * The Regions tally (#256, #260): each region (shown or hidden on the map, its suburbs assigned and with a page,
 * across every state) and under it its sub-regions and their members. A click flies there; a double-click makes it
 * the one being edited. Manage opens the Regions panel.
 */
@Component({
  selector: 'section[app-suburb-region-tally]',
  templateUrl: './suburb-region-tally.component.html',
  styleUrls: ['./suburb-region-tally.component.scss'],
})
export class SuburbRegionTallyComponent {
  constructor(
    public state: WorkspaceStateService,
    public catalogue: SuburbCatalogueService,
    public mapTools: MapToolsService,
    public nav: PanelNavService
  ) {}

  /** The row being edited: the active region, or the sub-region Sub-region mode or Assign mode is using. */
  isActiveSubRegion(id: string): boolean {
    const s = this.state;
    return (
      (s.mode === 'subregion' && id === s.activeSubRegion) ||
      (s.mode === 'assign' && id === s.assignSubRegion)
    );
  }
}
